import { EpicRefined } from 'interfaces/middleware'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import {
  AdvisorsRequestAction,
  AdvisorMeetingActions,
  AdvisorsRequestResponse,
  CancelAdvisorsRequestAction,
  ResetAdvisorsRequestStateAction,
} from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { mergeMap, map, delay, takeUntil } from 'rxjs/operators'
import { GET_ADVISORS_URL, GET_ADVISORS_PUBLIC_URL } from 'interfaces/ajax'
import { of, zip, merge } from 'rxjs'
import { normalize } from 'helpers/normalizeHelpers'
import FloatingPaneAction, { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import { SEARCH_ADVISOR_DURATION } from 'components/features/coaching/advisorMeeting/types/constants'
import { AdvisorUid } from 'components/features/coaching/advisor/types/advisor'
import { byType } from 'rxOperators/byType'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'


export const getAdvisorsEpic: EpicRefined<AdvisorMeetingActions | FloatingPaneAction | AjaxCatchExtraActions> = (action$, _, { get }) => action$.pipe(
  filterRequestOfType(AdvisorsRequestAction.type, 'request'),
  mergeMap((action) => {
    const { params } = action.payload

    const request$ = (() => {
      if (params.flow === 'landing') {
        const { flow, ...restFields } = params
        return get(GET_ADVISORS_PUBLIC_URL, { offset: 0, limit: 5, ...restFields })
      } else {
        const { flow, ...restFields } = params
        return get(GET_ADVISORS_URL, { offset: 0, limit: 5, ...restFields })
      }
    })()

    return zip(
      of(null).pipe(delay(SEARCH_ADVISOR_DURATION)),
      request$
    ).pipe(
      takeUntil(action$.pipe(
        byType(CancelAdvisorsRequestAction.type)
      )),
      takeUntil(action$.pipe(
        byType(ResetAdvisorsRequestStateAction.type)
      )),
      map((event) => event[1]),
      mergeMap(({ response }) => {
        const { results, previous, count, ...advisorsPagination } = response

        const { timeslots, timeslotsPagination, uids } = results.reduce((acc, item) => {
          const { results: dates, next } = item.timeslots
          return {
            timeslots: {
              ...acc.timeslots,
              [item.uid]: dates,
            },
            timeslotsPagination: {
              ...acc.timeslotsPagination,
              [item.uid]: {
                next,
                results: [],
              },
            },
            uids: [
              ...acc.uids,
              item.uid,
            ],
          }
        }, {
          timeslots: {},
          timeslotsPagination: {},
          uids: [],
        } as Pick<AdvisorsRequestResponse, 'timeslots' | 'timeslotsPagination'> & { uids: AdvisorUid[] })

        return merge(
          of(action.success({
            advisorsPagination: {
              ...advisorsPagination,
              results: uids,
            },
            advisors: normalize(results, 'uid'),
            timeslots,
            timeslotsPagination,
          })),
          of(modifyFloatingPaneActionCreator('advisor', { mode: 'request', step: 'schedule', fields: params })),
        )
      }),
      ajaxCatch((error) => merge(
        of(action.fail({ errorCode: error.status, errorsMap: error.response })),
        of(modifyFloatingPaneActionCreator('advisor', { mode: 'request', step: 'topic', fields: params })),
      )),
    )
  }),
)
